export const kContainerX = 10;
export const kContainerY = 0;
export const kMixerContainerWidth = 130;
export const kMixerContainerHeight = 190;
export const kCapHeight = 6;
export const kCapWidth = 40;
export const kBorder = 2;
export const kSpinnerContainerWidth = 180;
export const kSpinnerContainerHeight = 209;
export const kSpinnerRadius = Math.min(kMixerContainerWidth, kMixerContainerHeight) / 2;
export const kSpinnerX = (kContainerX / 2) + (kSpinnerContainerWidth / 2); //x center of spinner
export const kSpinnerY = (kContainerY / 2) + (kSpinnerContainerHeight / 2); //y center of spinner
export const kContainerCollisionTop = kContainerY + kBorder;
export const kContainerCollisionLeft = kContainerX + kBorder;
export const kContainerCollisionRight = kContainerCollisionLeft + kMixerContainerWidth - kBorder;
export const kContainerCollisionBottom = kContainerCollisionTop + kMixerContainerHeight - kBorder;
